import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'adjustDateOffset' })
export class AdjustDateOffsetPipe implements PipeTransform {
  transform(value: string, direction: 'add' | 'subtract' = 'add', valueForOffset: string = ""): Date {
    if (!value) return null;
    const offsetMs = new Date(valueForOffset || value).getTimezoneOffset() * 60000;
    return new Date(new Date(value).getTime() + (direction === 'add' ? offsetMs : -offsetMs));
  }
}
